import { useState, useEffect } from 'react';

/**
 * Custom Hook para gestionar el cambio de audiencia y sincronizar el hash de la URL
 * Pestañas soportadas: 'desarrolladores', 'comercios', 'clientes', 'repartidores'
 */
export function useTabNavigation(defaultTab = 'desarrolladores') {
  const [activeTab, setActiveTab] = useState(defaultTab);

  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (['desarrolladores', 'comercios', 'clientes', 'repartidores'].includes(hash)) {
      setActiveTab(hash);
    }
  }, []);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    window.location.hash = tab;
  };

  return { activeTab, handleTabChange };
}
